import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';
import Hero from '../../components/Hero/Hero';
import Services from '../../components/Services/Services';
import AIRPASection from '../../components/AIRPASection/AIRPASection';
import Clients from '../../components/Clients/Clients';
import Team from '../../components/Team/Team';
import CTA from '../../components/CTA/CTA';
import './Home.css';

const Home = () => {
  const { i18n } = useTranslation();
  const isFr = i18n.language === 'fr';

  return (
    <div className="home">
      <SEO
        title={isFr ? 'Accueil - Automatisation RPA, IA & Low-Code' : 'Home - RPA, AI & Low-Code Automation'}
        description={isFr
          ? 'OPTEAM Services : votre partenaire expert en automatisation RPA, Intelligence Artificielle et Low-Code. Transformez vos processus métiers et boostez votre productivité.'
          : 'OPTEAM Services: your expert partner in RPA automation, Artificial Intelligence and Low-Code. Transform your business processes and boost productivity.'
        }
        canonical="/"
      />
      <Hero />
      <Services />
      <AIRPASection />
      <Clients />
      <Team />
      <CTA />
    </div>
  );
};

export default Home;